
/**
 * Config default
 */
let options = {
    accordionToggleSelector: "[js-accordion]"
};


const init = (settings) => {
    const menuToggle = document.querySelectorAll(options.accordionToggleSelector);
    let accordionTxt = document.querySelectorAll('.accordion__btn-txt');

    for(let i = 0; i < menuToggle.length; i++) {
        menuToggle[i].querySelector('.accordion__top').addEventListener('click', (e) => {
            e.preventDefault();
            if (menuToggle[i].classList.contains('open')) {
                accordionTxt[i].style.opacity = 0;
                setTimeout(() => {
                    accordionTxt[i].innerHTML = 'Voir l\'offre';
                    accordionTxt[i].style.opacity = 1;
                }, 150);
                menuToggle[i].classList.remove('open');
            } else  {
                accordionTxt[i].style.opacity = 0;
                setTimeout(() => {
                    accordionTxt[i].innerHTML = 'Masquer l\'offre';
                    accordionTxt[i].style.opacity = 1;
                }, 150);

                menuToggle[i].classList.add('open');
            }
        });
    }
};

export default {
    init
}
